<odl-dialog
  class="offline-alert"
  [open]="message() !== undefined"
  (odl-before-close)="preventClose($event)"
>
  <div slot="header" class="header">
    <span>{{ 'OFFLINE_READING' | translate }}</span>
  </div>
  @if (message(); as message) {
    <p class="message">{{ message | translate }}</p>
  }
  @if (canGoBack()) {
    <div slot="footer" class="footer">
      <odl-button (click)="goToPlatform()">{{ 'GO_BACK' | translate }}</odl-button>
    </div>
  }
</odl-dialog>
